"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingClearActionType = "loading/clear";
function loadingClearAction(key) {
  return {
    type: exports.LoadingClearActionType,
    key: key
  };
}
exports.loadingClearAction = loadingClearAction;
exports.LoadingStartActionType = "loading/start";
function loadingStartAction(key) {
  return {
    type: exports.LoadingStartActionType,
    key: key
  };
}
exports.loadingStartAction = loadingStartAction;
exports.LoadingSuccessActionType = "loading/success";
function loadingSuccessAction(key) {
  return {
    type: exports.LoadingSuccessActionType,
    key: key
  };
}
exports.loadingSuccessAction = loadingSuccessAction;
exports.LoadingFailActionType = "loading/fail";
function loadingFailAction(key, message) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$reasons = _ref.reasons,
    reasons = _ref$reasons === void 0 ? [] : _ref$reasons,
    _ref$traceId = _ref.traceId,
    traceId = _ref$traceId === void 0 ? undefined : _ref$traceId,
    _ref$originalError = _ref.originalError,
    originalError = _ref$originalError === void 0 ? undefined : _ref$originalError;
  return {
    type: exports.LoadingFailActionType,
    key: key,
    error: {
      message: message,
      reasons: reasons,
      traceId: traceId,
      originalError: originalError
    }
  };
}
exports.loadingFailAction = loadingFailAction;